import React from "react"
import { Router } from "react-router-dom"

import App from "../containers/App.js"
import history from "../helpers/history.js"

const Root = () => (
  <Router history = { history }>
    <App />
  </Router>
)

export default Root


// WEBPACK FOOTER //
// ./src/containers/Root.js